import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AdminChallenge, ChallengeDetailsV2 } from '../../components';
import { connect } from 'react-redux';
class CompleteAdminChallenge extends Component {

  CompanyChallenge = () => {
    const { history, yearList, selectedYearInfo, companyInfo } = this.props;
    return (<AdminChallenge companyInfo={companyInfo} history={history} yearList={yearList} selectedYearInfo={selectedYearInfo} selectedTabId={1}/>)
  }

  render() {
    return (
      <Switch>
        <Route path="/company/challenges" render={this.CompanyChallenge} exact={true}/>
        <Route path="/company/challenges/completed/:id" component={ChallengeDetailsV2}/>
      </Switch>
    )
  }
}

CompleteAdminChallenge.propTypes = {
  companies: PropTypes.array,
  companyInfo: PropTypes.object,
  setCompany: PropTypes.func,
  role: PropTypes.string,
  history: PropTypes.object,
  selectedYearInfo: PropTypes.number,
  yearList: PropTypes.array,
  userPermissions: PropTypes.array,
  behaviorChallengeDetailsById: PropTypes.object,
  createChallenge: PropTypes.func,
  createBehaviorLibrary: PropTypes.func,
  getBehvaiorChallengeByIdAction: PropTypes.func,
  isAccountManager: PropTypes.bool
}

export default connect(null, null)(CompleteAdminChallenge);
